import React, { useRef } from "react";
import { getFormData, rankAndParseFields } from "./utils";
import styled from "styled-components";
import Radio from "common/Radio";
import { _MPLS_BOTH, _MPLS_L2, _MPLS_L3 } from "./api";

const Option = styled.div``;

export const MplsSettings = ({ onChange, defaults = {}, state = {}, bqn }) => {
  const form = useRef(null);
  const onInputChange = () => {
    const values = getFormData(form.current);
    onChange(rankAndParseFields(values, state));
  };
  return (
    <>
      <h2 className="card-inside-title">MPLS Support</h2>
      <form ref={form}>
        <Radio
          options={[
            {
              label: "Both L2+L3 after MPLS tags",
              value: _MPLS_BOTH,
            },
            {
              label: "Only L2 frames after MPLS tags",
              value: _MPLS_L2,
            },
            {
              label: "Only L3 packets after MPLS tags",
              value: _MPLS_L3,
            },
          ]}
          name="mpls.value"
          defaultValue={state.mpls ? state.mpls.value : defaults.mpls.value}
          onChange={onInputChange}
          itemWrapper={Option}
        />
      </form>
    </>
  );
};
